import Address from '../model/project/address';
import { StringHelper } from './string-helper';

export default class GoogleMapsHelper {
  static constructRequestAddress(address: Address): string {
    if (address != null) {
      let line1 = '';
      if (address.line1 != null) {
        let splitted = address.line1.split('bus:');
        line1 = StringHelper.isEmptyOrWhiteSpace(splitted[0])
          ? splitted[0]
          : splitted[0].replace(/,\s*$/, '');
      }
      return [line1, address.postalCode, address.city, address.country]
        .filter(s => s != null && s !== '')
        .join(', ');
    } else {
      return '';
    }
  }
}
